<template>
  <modal :showModalClose="false" class="confirm-dialog" v-if="open">
    <div slot="body">
      <div class="icon">
        <img src="/static/images/elements/icon_big_ok.png" /><br />
      </div>
      <div class="body">
        <h3>{{ this.textBody }}</h3>
      </div>
    </div>

    <div slot="footer">
      <vbutton
        label="common.yes"
        @click="confirm()" />
      <vbutton
        label="common.no"
        color="transparent"
        @click="cancel()" />
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/Modal.vue'

  export default {
    name: 'modal-confirm',

    components: {
      Modal
    },

    props: {
      textBody: {
        type: String,
        required: true
      },

      open: {
        type: Boolean,
        required: true
      }
    },

    methods: {
      confirm () {
        this.$emit('closeCofirm')
      },
      cancel () {
        this.$emit('closeCancel')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .confirm-dialog {

    .icon {
      padding-bottom: 25px;
    }

    .modal-body > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .body {
      width: 100%;

      h3 {
        width: 60%;
        max-width: 300px;
        margin: 0 auto;
      }

      & > div {
        max-height: 200px;
        overflow-y: auto;
      }
    }

    .modal-footer .vcv-button {
      margin: 0 auto !important;
    }
  }
</style>
